import {pick} from 'lodash'
import React, {useState} from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import {Consumer} from '../../context'
import {faSearch} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import './search-pattern.styl'

function searchPattern(context) {
  const {page, navigate, match, pattern, searching, section, action} = context
  if (pattern.length > 2 || pattern.length == 0) {
    const subject = context.query.subject || (searching == 'lessons' ? undefined : context.subject)
    const query = {
      pattern: pattern == '' ? undefined : pattern,
      subject,
      page: undefined,
      grade: context.query.grade
    }
    let path = match.path
    if (searching != 'lessons' && page != 'homework' && page != 'gradebook' && page != 'my-lessons' && page !='assessment' && section != 'add-lessons' && section != 'add-standards' && action != 'edit') path = `${match.path}/lessons`
    navigate({}, path, {preserveQuery: true, query})
  }
}

export default function SearchPattern ({searchPlaceholder, initialPattern}) {
  const [pattern, setPattern] = useState(initialPattern || '')
  return (<Consumer>{ (context) => {
    const searchContext = pick(context, ['page', 'match','navigate', 'query', 'subject', 'searching', 'section', 'action'])
    return (
      <div className="pattern filter">
        <div className="wrapper">
          <FontAwesomeIcon icon={faSearch} />
          <input
            value={pattern}
            placeholder={searchPlaceholder}
            onChange={e => setPattern(e.target.value)}
            onKeyPress = {({key}) => key == 'Enter' && searchPattern({...searchContext, pattern})}
          /> 
          <span className="button" onClick={() => searchPattern({...searchContext, pattern})}>
            <Text id="go_label" />
          </span>
        </div>
      </div>
    )}}</Consumer>)
}
